import { render, staticRenderFns } from "./DataQualityShowList.vue?vue&type=template&id=24723400&scoped=true"
import script from "./DataQualityShowList.vue?vue&type=script&lang=js"
export * from "./DataQualityShowList.vue?vue&type=script&lang=js"
import style0 from "./DataQualityShowList.vue?vue&type=style&index=0&id=24723400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24723400",
  null
  
)

export default component.exports